export default "__VITE_ASSET__l4v1uD2j__"